export const GBP_CURRENCY = 'GBP'

export const DEFAULT_CURRENCY = GBP_CURRENCY

export const DEFAULT_CURRENCY_SYMBOL = '£'

export const DEFAULT_LOCALE = 'en_GB'

export const DEFAULT_TIMEZONE = 'Europe/London'
